'use client'

import React from 'react'

type Props = {
    mass: number
    heightMax: number
    totalEnergy: number
    gravity: number
}

const WIDTH = 340
const HEIGHT = 200
const PAD_LEFT = 44
const PAD_RIGHT = 12
const PAD_TOP = 14
const PAD_BOTTOM = 28
const PLOT_W = WIDTH - PAD_LEFT - PAD_RIGHT
const PLOT_H = HEIGHT - PAD_TOP - PAD_BOTTOM

export default function EnergyConservationChart({ mass, heightMax, totalEnergy, gravity }: Props) {
    const hMax = Math.max(heightMax, 0.0001)
    const total = Math.max(totalEnergy, 0.0001)

    const xToSvg = (h: number) => PAD_LEFT + (h / hMax) * PLOT_W
    const yToSvg = (e: number) => PAD_TOP + PLOT_H - (e / total) * PLOT_H

    const steps = 40
    const pePoints: string[] = []
    const kePoints: string[] = []
    for (let i = 0; i <= steps; i++) {
        const h = (hMax * i) / steps
        const pe = Math.min(mass * gravity * h, total)
        const ke = Math.max(total - pe, 0)
        pePoints.push(`${xToSvg(h).toFixed(1)},${yToSvg(pe).toFixed(1)}`)
        kePoints.push(`${xToSvg(h).toFixed(1)},${yToSvg(ke).toFixed(1)}`)
    }

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <line x1={PAD_LEFT} y1={PAD_TOP} x2={PAD_LEFT} y2={HEIGHT - PAD_BOTTOM} stroke="#9ca3af" strokeWidth={1} />
            <line x1={PAD_LEFT} y1={HEIGHT - PAD_BOTTOM} x2={WIDTH - PAD_RIGHT} y2={HEIGHT - PAD_BOTTOM} stroke="#9ca3af" strokeWidth={1} />
            <text x={PAD_LEFT} y={HEIGHT - 8} fontSize={10} fill="#6b7280">Height (m)</text>
            <text x={4} y={PAD_TOP + 6} fontSize={10} fill="#6b7280">Energy (J)</text>
            <line x1={PAD_LEFT} y1={yToSvg(total)} x2={WIDTH - PAD_RIGHT} y2={yToSvg(total)} stroke="#9ca3af" strokeWidth={1} strokeDasharray="3,3" />
            <polyline points={pePoints.join(' ')} fill="none" stroke="#16a34a" strokeWidth={2} />
            <polyline points={kePoints.join(' ')} fill="none" stroke="#dc2626" strokeWidth={2} />
            <text x={WIDTH - PAD_RIGHT - 60} y={PAD_TOP + 12} fontSize={9} fill="#16a34a">PE</text>
            <text x={WIDTH - PAD_RIGHT - 40} y={PAD_TOP + 12} fontSize={9} fill="#dc2626">KE</text>
        </svg>
    )
}
